/**
 * @generated SignedSource<<c827c299b1d6b7a056bba9ccf58475a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type desktopRecorderApiGetUploadLinksMutation$variables = {
  audioFileExtension: string;
  meetingRecordingId: string;
};
export type desktopRecorderApiGetUploadLinksMutation$data = {
  readonly getLocalRecordingUploadLinks: {
    readonly audioFields: any;
    readonly audioUrl: string;
  } | null;
};
export type desktopRecorderApiGetUploadLinksMutation = {
  response: desktopRecorderApiGetUploadLinksMutation$data;
  variables: desktopRecorderApiGetUploadLinksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audioFileExtension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audioFileExtension",
        "variableName": "audioFileExtension"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "GetLocalRecordingUploadLinks",
    "kind": "LinkedField",
    "name": "getLocalRecordingUploadLinks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "audioUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "audioFields",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiGetUploadLinksMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "desktopRecorderApiGetUploadLinksMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3d13b6d7f2e1435b0d74644774f1d115",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiGetUploadLinksMutation",
    "operationKind": "mutation",
    "text": "mutation desktopRecorderApiGetUploadLinksMutation(\n  $meetingRecordingId: ID!\n  $audioFileExtension: String!\n) {\n  getLocalRecordingUploadLinks(meetingRecordingId: $meetingRecordingId, audioFileExtension: $audioFileExtension) {\n    audioUrl\n    audioFields\n  }\n}\n"
  }
};
})();

(node as any).hash = "13ce060f75d89ab5b98746867c435b5f";

export default node;
